import * as React from 'react';
import { IDropdownProps } from './IDropdown';

const Dropdown = (props: IDropdownProps) => {
    return (
        <div className={props.className} style={{ ...props.style }}>
            <label htmlFor={props.name}>{props.title}</label>
            <select name={props.name} id={props.name} onChange={props.onChange} value={props.value} defaultValue={props.defaultValue} disabled={props.disabled}>
                {props.options.map(option => {
                    let selected = props.defaultValue === option.label || props.defaultValue === option.value;
                    return (
                        <option selected={selected} key={option.label} value={option.value}>
                            {option.label}
                        </option>
                    );
                })}
            </select>
        </div>
    );
};

export default Dropdown;
